<template>
  <div class="contentBody">
    <div class="contentBody__title">
      <span class="text">ニックネーム変更</span>
    </div>
    <div class="contentBody__section u-pd-t-3">
      <form
      :action="action" :method="method"
      @submit.prevent="handleSubmit()" ref="profileForm">
      <input type="hidden" name="_token" :value="csrfToken">

      <!--自分-->
      <div>
        <form-input
        name="nickname"
        type="text"
        v-model="userAccount.nickname"
        label="ニックネーム"
        placeholder="結果に表示される愛称"
        :value="userAccount.nickname"
        :validation="{ rules: {
          required: true,
          max: 15
          } }"
          >
        </form-input>

          <div class="btnGroup space u-mg-t-4">
            <a class="btn"
            href="/user/account"
            data-block="true"
            data-color="brand"
            data-stroke="true"
            >戻る</a>

            <button class="btn"
            data-block="true"
            data-color="brand"
            >この内容で登録</button>
          </div>

        </div>
      </form>
    </div>
  </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex'
import { FORM_LABELS, FORM_OPTIONS } from '@/CONSTS'
import * as type from '@/utvStore/store/mutation-types'
import dataControl from './EntryForm/mixins/dataControl'
import fetchAccountData from '@/utils/fetchAccountData'
import convertUserInfo from '@/utils/convertUserInfo'

export default {
  name: 'nickname-form',
  props: {
    action: String,
    method: String
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      userAccount: state => state.account.profile
    }),
    ...mapGetters(['isLoggedIn'])
  },
  mounted() {
    if (this.isLoggedIn) {
      // ユーザー情報をフロントで拾う？
      // this.$store.dispatch(type.GET_ACCOUNT, this.accessToken)
    }
  },
  data() {
    return {
      csrfToken: window.Laravel.csrfToken,
      FORM_LABELS,
      FORM_OPTIONS,
      profile: Object
    }
  },
  methods: {
    handleSubmit() {
      this.updateProfile()
      .then(() => {
        this.$refs.profileForm.submit()
      })
      .catch(this.onSubmitError)
    },
    updateProfile() {
      // 未ログイン(非会員状態)の場合は何もしない
      if (!this.isLoggedIn || !this.accessToken) {
        return Promise.resolve()
      }
      const formData = $(this.$refs.profileForm).serializeArray()
      formData.forEach(item => {
        Object.assign(data, {
          [item.name]: item.value
        })
      })
      data = convertUserInfo(data)
      Object.assign(data, {
        access_token: this.accessToken
      })
      return fetchAccountData.updateProfile(data)
    },
    onSubmitError(error) {
      this.$message({
        message:
        '認証情報に誤りがあるため、ログアウトしました。お手数ですが再度ログインしてください。',
        type: 'error'
      })
      //  this.$store.dispatch(type.LOGOUT)
      //  throw new Error(error)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/NicknameForm.vue